import * as React from 'react';
import {formatPostalAddress} from "./locationAddress/util";
import LocationGroupOfTypeSelector from "./LocationGroupOfTypeSelector";

export function LocationSelector(props) {
  return <LocationGroupOfTypeSelector
    type="Location"
    renderOption={x => x.name + ", " + formatPostalAddress(x.address)}
    {...props} />
}
